(function () {
  'use strict';

  var busy = false;

  function cartUrl() {
    return (window.routes && window.routes.cartUrl) || '/cart';
  }

  function loading(state) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:' + state, { bubbles: true }));
  }

  async function updateBundle(bundleId, quantity) {
    if (busy) return;
    busy = true;
    loading('start');

    try {
      var cartResponse = await fetch(cartUrl() + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!cartResponse.ok) throw new Error('Unable to read cart');

      var cart = await cartResponse.json();
      var updates = {};

      cart.items.forEach(function (item) {
        if (item.properties && item.properties['_Fullord bundle'] === bundleId) {
          updates[item.key] = quantity;
        }
      });

      if (!Object.keys(updates).length) throw new Error('Engraving bundle was not found');

      var updateResponse = await fetch(cartUrl() + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      });
      if (!updateResponse.ok) throw new Error('Unable to update engraving bundle');

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      console.error('[Fullord cart bundle]', error);
      window.location.reload();
    } finally {
      busy = false;
      loading('end');
    }
  }

  function intercept(element, quantity, event) {
    var bundleId = element.getAttribute('data-fullord-bundle-id');
    if (!bundleId) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    updateBundle(bundleId, Math.max(parseInt(quantity, 10) || 0, 0));
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-fullord-bundle-id][data-action="remove-item"], [data-fullord-bundle-id][data-action="update-item-quantity"]');
    if (control) intercept(control, control.getAttribute('data-quantity'), event);
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('.QuantitySelector__CurrentQuantity[data-fullord-bundle-id]')) {
      intercept(event.target, event.target.value, event);
    }
  }, true);
})();
